import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useActiveOrgWorkspaces } from "@/hooks/organizations";
import { WorkspaceInviteFormValues } from "@/schemas/workspace-invite";
import { Users } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

interface SelectWorkspaceProps {
  workspace?: { name: string; id: number };
}

const SelectWorkspace = ({ workspace }: SelectWorkspaceProps) => {
  const form = useFormContext<WorkspaceInviteFormValues>();
  const workspaces = useActiveOrgWorkspaces();

  // Set the form value when workspace prop is provided
  useEffect(() => {
    if (workspace) {
      form.setValue("workspace_id", workspace.id);
    }
  }, [workspace, form]);

  return (
    <FormField
      control={form.control}
      name="workspace_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Workspace <span className="text-red-500">*</span>
          </FormLabel>
          <FormControl>
            <Select
              onValueChange={(value) => field.onChange(Number(value))}
              defaultValue={
                workspace ? workspace.id.toString() : field.value?.toString()
              }
              disabled={!!workspace}
            >
              <SelectTrigger>
                <div className="flex items-center gap-2">
                  <Users className="h-4 text-gray-400" />
                  <SelectValue
                    placeholder={
                      workspace ? workspace.name : "Select a workspace"
                    }
                  />
                </div>
              </SelectTrigger>
              <SelectContent>
                {workspace ? (
                  <SelectItem
                    key={workspace.id}
                    value={workspace.id.toString()}
                  >
                    {workspace.name}
                  </SelectItem>
                ) : (
                  workspaces.map((ws) => (
                    <SelectItem key={ws.id} value={ws.id.toString()}>
                      {ws.name}
                    </SelectItem>
                  ))
                )}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default SelectWorkspace;
